import { type ReactNode } from 'react';
import { classes } from 'src/modules/shared/utils/styles.util';
import { DayChip } from 'src/modules/shared/components/atoms/day-chip';

interface DateGroupItemsProps {
  /** Optional spacing for the event list. */
  itemsClassName?: string;
  date: Date;
  children: ReactNode;
}

export function DateGroupItems({
  date,
  children,
  itemsClassName,
}: DateGroupItemsProps) {
  const dateGroupClassName = classes(
    'flex justify-center bg-transparent py-3 sticky top-0 z-[1]'
  );

  return (
    <div className="flex flex-col gap-4">
      <div className={dateGroupClassName}>
        <DayChip date={date} />
      </div>
      <div className={classes('flex flex-col gap-4', itemsClassName)}>
        {children}
      </div>
    </div>
  );
}
